
import {
  computed,
  defineComponent, onMounted, reactive, SetupContext, toRaw, watch,
} from 'vue';
import {
  Form, Modal, Radio, Input, Select, DatePicker, Button, message,
} from 'ant-design-vue';
import CheckboxForClass from '@/components/CheckboxForClass.vue';
import moment, { Moment } from 'moment';
import commonStore from '@/store/common';
import { cloneDeep } from 'lodash';
import { getDateForName } from '@/lib';
import asynButtonVue from '@/components/asynButton.vue';
import { Class } from '../../userManager/js/classModule';

// definitions['AssignHomework']
interface EditForm {
  assignHomeName: string;
  beginTime: string;
  endTime: string;
  classIds: string[];
  assignmentId: string;
  assignmentModel: number;
  assignUserId: string;
  assignStatus?: number; // 分配状态
}
export default defineComponent({
  components: {
    aModal: Modal,
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aSelect: Select,
    aSelectOption: Select.Option,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    aRangePicker: DatePicker.RangePicker,
    CheckboxForClass,
    aButton: asynButtonVue,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['on-cancel', 'on-ok'],
  setup(this, props, ctx: SetupContext) {
    const basicVisible = computed(() => props.visible);
    const basicLoading = computed(() => props.loading);
    const editForm: EditForm = reactive({
      assignHomeName: '',
      beginTime: '',
      endTime: '',
      classIds: [],
      assignmentId: '',
      assignmentModel: 0,
      assignUserId: commonStore.getState().code,
      assignStatus: 0,
    });
    const loadings = {
      continue: false,
    };
    // 班级
    const classModule = reactive(new Class());

    const disabledDate = (current: Moment) => current && current < moment().startOf('day');
    // 日期选择
    const dateOk = (value: [string, string]) => {
      [editForm.beginTime, editForm.endTime] = value;
    };
    // 班级选择
    const checkChange = (classIds: string[]) => {
      editForm.classIds = [...classIds];
    };

    // 检查时间
    const checkTime = (start: string, end: string) => new Date(start).getTime() >= new Date(end).getTime();

    const onCancel = () => {
      ctx.emit('on-cancel');
    };
    const onOk = () => {
      console.log(toRaw(editForm), 'editForm');
      if (editForm.classIds.length === 0) {
        message.error('请至少选择一个班级！');
      } else if (!editForm.beginTime || !editForm.endTime) {
        message.error('请先选择作业完成时间！');
      } else if (checkTime(editForm.beginTime, editForm.endTime)) {
        message.error('结束时间必须大于开始时间！');
      } else {
        ctx.emit('on-ok', { ...cloneDeep(toRaw(editForm)) });
      }
    };

    onMounted(async () => {
      await classModule.query({ pageSize: 99999, pageNo: 1 });
    });

    watch(() => props.visible, () => {
      if (props.visible) {
        editForm.assignmentModel = 1;
        loadings.continue = true;
      } else {
        loadings.continue = false;
      }
    }, { deep: true });
    watch(() => props.currentData, () => {
      editForm.assignmentId = props.currentData.id;
      editForm.assignHomeName = getDateForName(props.currentData.jobName);
    }, { deep: true, immediate: true });
    return {
      // data
      basicVisible,
      basicLoading,
      editForm,
      loadings,
      disabledDate,
      classModule,
      // method
      dateOk,
      checkChange,
      onCancel,
      onOk,
    };
  },
});
